<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo"
      @clickOnBackground="logState"
    >
      <div class="success-container">
<!--        <svg-icon-->
<!--          name="close"-->
<!--          class="h-4 cursor-pointer ico"-->
<!--          original-->
<!--          @click="fermer"-->
<!--        />-->

        <Carousel
          ref="carousel5"
          :controls="false"
          :per-page="1"
          :loop="true"
          :pagination-enabled="false"
          :speed="1500"
          class="car"
        >
          <Slide
            v-for="(item, index) in donnes"
            :key="index"
          >
            <img
              :src="item"
              alt=""
              class=""
            >
          </Slide>
        </Carousel>

        <div class="flex justify-center mt-4 but">
          <svg-icon
            name="ic_prev"
            class="md:h-10 h-6 cursor-pointer mr-4"
            original
            @click="goToSlidePrev"
          />
          <svg-icon
            name="ic_next"
            class="md:h-10 h-6 cursor-pointer"
            original
            @click="goToSlideNext"
          />
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popup-base2'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'Success',
  components: {
    PopupBase,
    Slide,
    Carousel
  },
  props: {
    wantToMakeOffer: {
      type: Boolean,
      default: false
    },
    donnes: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },

  methods: {
    goToSlidePrev () {
      this.$refs.carousel5.goToPage(this.$refs.carousel5.getPreviousPage())
    },
    goToSlideNext () {
      this.$refs.carousel5.goToPage(this.$refs.carousel5.getNextPage())
    },
    fermer () {
      this.activeOk = false
      this.$emit('oga', false)
    },
    yes () {
      this.activeOk = false
      this.$emit('oga', true)
    },
    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
      this.activeOk = false
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/style/sass/mixin";

    .success-container {
      width: 100%;
      background-color: white;
      border-radius: 10px;
      padding: 0px 0px 0px 0px;

      height: auto;
      margin: auto;
    }
    .car{
      border-radius: 10px;
    }
    .but{
      margin-top: -70px;
      z-index: 999;
      position: relative;
    }
    .titre{
      font-style: normal;
      font-weight: normal;
      font-size: 28.3206px;
      line-height: 160%;
    }
    .button{
      background-color: $dev-green;
      width: 226.56px;
      height: 47.2px;
      border-radius: 0px;
      border: none;
      font-weight: 600;
      font-size: 18.8804px;
      line-height: 23px;
      color: $white;
    }
    .svg-fill{
      fill: transparent;
    }
    img{
      border-radius: 10px;
    }

    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
      }
      .titre{
        font-size: 20px;
      }
    }
</style>
